import React, { memo } from "react";
import { 
  ComposableMap, 
  Geographies, 
  Geography
} from "react-simple-maps";
import styles from "./MapChart.module.css";

// US states map
const geoUrl = "https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json";

const MapChart = ({ stateData }) => {
  const safeStateData = Array.isArray(stateData) ? stateData : [];
  
  if (safeStateData.length === 0) {
      return <div className={styles.infoContainer}>No state availability data available for this product</div>;
  }

  // Count available states
  const availableStates = safeStateData.filter(state => state && state.available).length;

  return (
    <div className={styles.mapWrapper}>
      <div className={styles.mapContainer}>
        {/* Show message when no states have availability */}
        {availableStates === 0 && (
          <div className={styles.noAvailabilityMessage}>
            Not currently available in any Best Buy stores across the US
          </div>
        )}
        
        <ComposableMap 
            projection="geoAlbersUsa"
            projectionConfig={{
                scale: 1000,
                center: [0, 0]
            }}
            style={{
                width: "100%",
                height: "100%"
            }}
            >
            <Geographies geography={geoUrl}>
            {({ geographies }) =>
                geographies.map(geo => {
                // Use the name property instead of postal code
                const stateName = geo.properties.name;
                
                // Find the state data - match by name instead of code
                const stateInfo = stateData.find(s => 
                    s.stateName === stateName // Direct name match
                );
                
                // Default to unavailable if no data
                const available = stateInfo ? stateInfo.available : false;
                
                return (
                    <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill={available ? "#4da375" : "#a34d5d"}
                    stroke="#FFFFFF"
                    strokeWidth={0.5}
                    style={{
                        default: { outline: "none" },
                        hover: {
                        fill: available ? "#6FD19A" : "#D16F79",
                        outline: "none",
                        cursor: "pointer"
                        },
                        pressed: { outline: "none" }
                    }}
                    title={`${stateName}: ${available ? "Available" : "Not Available"}`}
                    />
                );
                })
            }
            </Geographies>
        </ComposableMap>
      </div>
      
      <div className={styles.legend}>
        <div className={styles.legendItem}>
          <div className={styles.legendColor} style={{ backgroundColor: "#4da375" }}></div>
          <span>Available</span>
        </div>
        <div className={styles.legendItem}>
          <div className={styles.legendColor} style={{ backgroundColor: "#a34d5d" }}></div>
          <span>Unavailable</span>
        </div>
      </div>
      
      <div className={styles.statsSection}>
        Available in {availableStates} {availableStates === 1 ? 'state' : 'states'}
      </div>
    </div>
  );
};

export default memo(MapChart);